import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Container, Box, Modal, IconButton, Button } from "@mui/material";
import DriveWithUsState from "../../Hooks/DriveWithUs.state";
import Header from "Layout/Header";
import AuthState from "Hooks/Authinctication.state";
import { Card, Typography, Avatar, Tabs, Tab, Divider, Stack } from "@mui/material";
import { IMAGES_URL, BASE_URL } from "Utils/URLs";
import { getDisplayUrl, isLocalUploadPath, resolveMediaUrl } from "Utils/mediaUrl";
import RenderStatus from "Component/RenderStatus";
import PdfCanvasPreview from "../../Component/PdfCanvasPreview";
import PdfThumbnail from "../../Component/PdfThumbnail";
import PartnerWithUsState from "Hooks/PartnerWithUs.state";
import FreeRideState from "Hooks/FreeRide.state";
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';
import CardContent from "@mui/material/CardContent";
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "Layout/Footer";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.mjs";
import JSZip from "jszip";
import { toast } from "react-toastify";



const theme = createTheme();
const API_BASE = String(BASE_URL || "").replace(/\/+$/, "").endsWith("/api")
  ? String(BASE_URL || "").replace(/\/+$/, "")
  : `${String(BASE_URL || "").replace(/\/+$/, "")}/api`;

function ProfileCard(props) {
  const location = useLocation()
  const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };
  const { id: paramId } = useParams()

  const styles = {
    details: {
      padding: "1rem",
      borderTop: "1px solid #e1e1e1"
    },
    value: {
      padding: "1rem 2rem",
      borderTop: "1px solid #e1e1e1",
      color: "#899499"
    }
  };
  const formatDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return "";
    return dt.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  };
  const { publicData, GetPublicProfile } = AuthState()

  const queryParams = getQueryParams(location.search);
  const dataParam = queryParams.get('data');
  const profilePayload = dataParam || paramId;

  // Some documents are not public (CORS/ACL). Use server endpoints when possible.
  const getDocumentDownloadUrl = (file_name, usePublicProfileEndpoint = true) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    // Local migrated files → public /api/uploads URL
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return resolveMediaUrl(s);
    }
    if (usePublicProfileEndpoint && profilePayload) {
      return `${API_BASE}/public_profile/document?profile=${encodeURIComponent(profilePayload)}&file_name=${encodeURIComponent(s)}`;
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`;
    }
    return `${IMAGES_URL}/${s}`;
  };

  // For shared-link (dataParam): use POST so long profile payload is in body and URLs don't break
  const getDocumentDownloadRequest = (file_name) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return { url: resolveMediaUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return { url: `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (!profilePayload) return { url: `${IMAGES_URL}/${s}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    const usePost = !!dataParam;
    if (usePost) {
      return {
        url: `${API_BASE}/public_profile/document`,
        options: {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ profile: profilePayload, file_name: s }),
          mode: "cors",
          credentials: "omit",
        },
      };
    }
    return { url: getDocumentDownloadUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
  };


  useEffect(() => {
    if (profilePayload) GetPublicProfile(profilePayload);
  }, [paramId, location.search])








  return (
    <Card variant="outlined">

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {/* CARD HEADER START */}
        <Grid item sx={{ p: "1.5rem 0rem", textAlign: "center" }}>
          {/* PROFILE PHOTO */}
          <Box sx={{ display: "flex", justifyContent: "center" }} >
            <Avatar
              sx={{ width: 100, height: 100, mb: 1.5 }}
              src={publicData?.profile_pic ? getDisplayUrl(publicData.profile_pic, IMAGES_URL) : ""}
            ></Avatar>
          </Box>

          {/* DESCRIPTION */}
          <Typography variant="h6">{publicData?.name}</Typography>
          <Typography color="text.secondary">{publicData?.email}</Typography>
        </Grid>
        {/* CARD HEADER END */}

        {/* DETAILS */}
        <Grid container>
          <Grid item xs={12}>
            {
              publicData?.uuid && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>User Id</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.uuid}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.phone && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Phone</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.phone}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.street_name && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Street Name</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.street_name}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.address && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Address</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.address}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.city && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>City</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.city}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.apt && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Apt, Suit, Unit, etc</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.apt}</Typography>
                    </Grid>
                  </Grid>
                </>

              )
            }
            {
              publicData?.state && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>State</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.state}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }
            {
              publicData?.zip_code && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Zip Code</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{publicData?.zip_code}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }

            {
              publicData?.status && (
                <>
                  <Grid container >
                    <Grid item xs={6} >
                      <Typography style={styles.details}>Status</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} >
                      <Typography style={styles.value}>{RenderStatus(publicData.status)}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }

            {
              publicData?.company && (
                <>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography style={styles.details}>Company</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"}>
                      <Typography style={styles.value}>{publicData?.company}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }

            {
              publicData?.created_at && (
                <>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography style={styles.details}>Started from</Typography>
                    </Grid>
                    <Grid item xs={6} textAlign={"end"}>
                      <Typography style={styles.value}>{formatDate(publicData.created_at)}</Typography>
                    </Grid>
                  </Grid>
                </>
              )
            }



          </Grid>


        </Grid>

        {/* BUTTON */}

      </Grid>
    </Card>
  );
}




function SettingsCard(props) {
  const location = useLocation()
  const { id: paramId } = useParams()
  const getQueryParams = (search) => {
    return new URLSearchParams(search);
  };
  const { publicData, GetPublicProfile } = AuthState()
  const queryParams = getQueryParams(location.search);
  const dataParam = queryParams.get('data');
  const profilePayload = dataParam || paramId;

  // Some documents are not public (CORS/ACL). Use server endpoints when possible.
  const getDocumentDownloadUrl = (file_name, usePublicProfileEndpoint = true) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    // Local migrated files → public /api/uploads URL
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return resolveMediaUrl(s);
    }
    if (usePublicProfileEndpoint && profilePayload) {
      return `${API_BASE}/public_profile/document?profile=${encodeURIComponent(profilePayload)}&file_name=${encodeURIComponent(s)}`;
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`;
    }
    return `${IMAGES_URL}/${s}`;
  };

  // For shared-link (dataParam): use POST so long profile payload is in body and URLs don't break
  const getDocumentDownloadRequest = (file_name) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return { url: resolveMediaUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return { url: `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (!profilePayload) return { url: `${IMAGES_URL}/${s}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    const usePost = !!dataParam;
    if (usePost) {
      return {
        url: `${API_BASE}/public_profile/document`,
        options: {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ profile: profilePayload, file_name: s }),
          mode: "cors",
          credentials: "omit",
        },
      };
    }
    return { url: getDocumentDownloadUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
  };
  const styles = {
    details: {
      padding: "1rem",
      borderTop: "1px solid #e1e1e1"
    },
    value: {
      padding: "1rem 2rem",
      borderTop: "1px solid #e1e1e1",
      color: "#899499"
    }
  };



  const { formBusy, UpdateDriveWithUs, response, driveWithUsData, loading, GetDriveWithUs, oldData } = DriveWithUsState()
  const { GetPartnerWithUs, partnerWithUsData } = PartnerWithUsState()
  const { GetFreeRide, freeRideData } = FreeRideState()
  const [value, setValue] = React.useState("one");
  const [openDrawer, setOpenDrawer] = useState(false)
  const [drawerData, setDrawerData] = useState({})
  const [file, setFile] = useState("")
  const [expiry, setExipry] = useState("")
  const [imageUrl, setImageUrl] = useState("")
  const [partnerDrawer, setpartnerDrawer] = useState(false)
  const [fileError, setFileError] = useState({ error: false, errorMessage: "" })
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)



  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });
    if (profilePayload) GetPublicProfile(profilePayload);
  }, [paramId, location.search])


  const formatDate = (date) => {
    const d = new Date(date)
    d.setFullYear(d.getFullYear());
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`
  }

  const hanldeOpenDrawer = (id, image, date, formName, field_name) => {
    console.log(id, image, date)
    if (date != undefined) {

      setDrawerData({
        id: id,
        image: image,
        date: formatDate(date),
        formName: formName,
        field_name: field_name,
      })
    } else {
      setDrawerData({
        id: id,
        image: image,
        date: null,
        formName: formName,
        field_name: field_name,
      })
    }

    setImageUrl(CheckExtension(image) === "pdf" ? "/driver_forms/assets/images/pdf.png" : CheckExtension(image) === "docx" ? "/driver_forms/assets/images/word.png" : resolveFileUrl(image))
    setOpenDrawer(true)
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [pdfEditOpen, setPdfEditOpen] = useState(false);

  const getExtension = (file) => {
    const s = String(file || "");
    const clean = s.split("?")[0].split("#")[0];
    const parts = clean.split(".");
    return parts.length > 1 ? String(parts[parts.length - 1]).toLowerCase() : "";
  };

  const resolveFileUrl = (image) => {
    const s = String(image || "");
    if (s.startsWith("http://") || s.startsWith("https://")) return s;
    return `${IMAGES_URL}/${s}`;
  };

  const openPdfPreview = (url) => {
    const u = String(url || "");
    setPdfPreviewUrl(`${u}${u.includes("?") ? "&" : "?"}v=${Date.now()}#navpanes=0&toolbar=0`);
    setPdfEditOpen(false);
    setPdfPreviewOpen(true);
  };

  const closePdfPreview = () => {
    setPdfPreviewOpen(false);
    setPdfPreviewUrl("");
    setPdfEditOpen(false);
  };

  const handleOpenModal = (image) => {

    const ext = getExtension(image)
    const fileUrl = resolveFileUrl(image)
    if (ext === "docx") {

      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = image;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);


    } else if (ext === "pdf") {
      openPdfPreview(fileUrl)
    } else {
      setOpenModal(true)
      setOpenImage(image)
      setTimeout(() => {
        $(document).ready(() => {
          $(`[href="${fileUrl}"]`).click();
        });
      }, 0);
    }


  }



  const CheckExtension = (file) => getExtension(file)

  const FormatDate = (dates) => {
    const date = new Date(dates)
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
    return formattedDate
  }

  const Label = (form_name) => {
    switch (form_name) {
      case "drive_with_us":
        return "Drive With Us"
      case "free_ride":
        return "Free Ride"
      case "partner_with_us":
        return "Partner With Us"

      default:
        break;
    }
  }







  // const hanldePartnerDrawer = () => {
  //   setDrawerData({
  //     institution_name: partnerWithUsData[0].institution_name,
  //     industry: partnerWithUsData[0].industry,
  //     other_industry: partnerWithUsData[0].other_industry,
  //     additional_info: partnerWithUsData[0].additional_info
  //   })
  //   setpartnerDrawer(true)
  // }



  return (
    <Card variant="outlined" sx={{ height: "100%", width: "100%" }}>
      {openModal && (
        <a
          href={`${resolveFileUrl(openImage)}`}
          data-lightbox="gallery"
          data-title="Image"
          style={{ display: 'none' }}
        >
          Open Image
        </a>
      )}
      <Modal open={pdfPreviewOpen} onClose={closePdfPreview}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", md: "80%" },
            height: { xs: "85vh", md: "85vh" },
            bgcolor: "#fff",
            boxShadow: 24,
            borderRadius: 2,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, py: 1, borderBottom: "1px solid #eee" }}>
            <Typography sx={{ fontWeight: 600 }}>PDF Preview</Typography>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Button variant="outlined" size="small" disabled={!pdfPreviewUrl} onClick={() => setPdfEditOpen((v) => !v)}>
                {pdfEditOpen ? "Close Edit" : "Edit"}
              </Button>
              {pdfEditOpen && (
                <Button
                  variant="contained"
                  size="small"
                  sx={{ backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                  disabled={!pdfPreviewUrl}
                  onClick={() => {
                    if (pdfPreviewUrl) window.open(pdfPreviewUrl, "_blank", "noopener,noreferrer");
                  }}
                >
                  Open
                </Button>
              )}
              <IconButton onClick={closePdfPreview}>
                ✕
              </IconButton>
            </Box>
          </Box>
          <Box sx={{ flex: 1 }}>
            {pdfPreviewUrl ? (
              pdfEditOpen ? (
                <iframe
                  key={`${String(pdfPreviewUrl).split("#")[0]}|iframe`}
                  title="pdf-preview"
                  src={String(pdfPreviewUrl).split("#")[0]}
                  style={{ width: "100%", height: "100%", border: "none" }}
                />
              ) : (
                <PdfCanvasPreview url={pdfPreviewUrl} />
              )
            ) : null}
          </Box>
        </Box>
      </Modal>

      {/* <Drawer anchor="right" open={partnerDrawer} onClose={() => setpartnerDrawer(false)} >
          <Box sx={{ width: 700 }} >
            <Container>
              <Typography variant="h5" pt={4} textAlign={"center"}  >Partner with us</Typography>
              <Grid container pt={4}   >
                <Grid md={6} px={2} pt={3} >
                  <label style={{ color: "#000" }} >Institution name</label>
                  <TextField value={drawerData.institution_name} onChange={(e) => setDrawerData((prev) => ({ ...prev, institution_name: e.target.value }))} fullWidth />
                </Grid>
                <Grid md={6} px={2} pt={3} >
                  <label style={{ color: "#000" }} >Industry</label>
                  <TextField fullWidth value={drawerData.industry} onChange={(e) => setDrawerData((prev) => ({ ...prev, industry: e.target.value }))} />
                </Grid>
                <Grid md={6} px={2} pt={3} >
                  <label style={{ color: "#000" }} >Other industry</label>
                  <TextField fullWidth value={drawerData.other_industry} onChange={(e) => setDrawerData((prev) => ({ ...prev, other_industry: e.target.value }))} />
                </Grid>
                <Grid md={6} px={2} pt={3} >
                  <label style={{ color: "#000" }} >Additional Info</label>
                  <TextField fullWidth value={drawerData.additional_info} onChange={(e) => setDrawerData((prev) => ({ ...prev, additional_info: e.target.value }))} />
                </Grid>
  
              </Grid>
              <Box px={5} pt={3} >
                <Button onClick={handleUpdate} fullWidth size="large" variant="contained" color="secondary">
                  {formBusy ? "Please wait...." : "Update"}
                </Button>
              </Box>
            </Container>
          </Box>
        </Drawer> */}
      {/* TABS + DOWNLOAD BUTTON */}
      <br></br>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, pr: { xs: 1, md: 2 } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="#76a521"
          indicatorColor="#76a521"
          sx={{
            flex: "1 1 auto",
            minWidth: 0,
            '& .MuiTabs-indicator': {
              backgroundColor: '#76a521',
            },
            '& .MuiTab-root': {
              color: '#76a521',
              '&.Mui-selected': {
                color: '#76a521',
              },
            },
          }}
        >
          <Tab value="one" label={Label(publicData?.form_name)} />
          {publicData?.form_name === "drive_with_us" && oldData.length !== 0 ?
            <Tab value="two" label="Old Data" />
            : null}
        </Tabs>
        {props.downloadButton}
      </Box>
      <Divider></Divider>

      {/* MAIN CONTENT CONTAINER */}
      <form>
        <CardContent
          sx={{
            p: 3,

            textAlign: { xs: "center", md: "start" }
          }}
        >
          {value === "one" ?
            publicData?.form_name === "drive_with_us" ?
              <Grid container spacing={2} >

                {publicData?.driveWithUsData.map((item) => (
                  (item.field_name === "liability_insurance" || item.field_name === "social_security" || item.field_name === "tlc_license" || item.field_name === "fh1_insurance" || item.field_name === "diamond_sticker" || item.field_name === "car_inspection" ||item.field_name === "driver_license" || item.field_name === "vehicle_reg" ) && (
                    <Grid item xs={12} lg={4} key={item._id} >
                      <Card elevation={4} sx={{ height: "100%", width: "100%" }} >
                        <Grid container mt={3}  >
                          <Grid xs={12} justifyContent={"space-around"} alignItems={"center"} flexDirection={"column"} display={"flex"}  >
                            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} spacing={2} px={1} mb={2}  >
                              {RenderStatus(String(item.file_status))}


                            </Stack>

                            <Typography fontWeight={900} fontSize={12} mb={1} >{item.field_title}</Typography>
                            {item.file_number && (
                              <Typography mb={1} fontSize={14} >{item.file_number}</Typography>
                            )}
                            {item.plate_number && item.pin_number && item.pin_number !== "undefined" && item.plate_number !== "undefined" ?
                              <Stack direction={"row"} justifyContent={"space-between"} width="100%" alignItems={"center"}  >

                                <Box width="100%" textAlign={"center"} sx={{ maxWidth: "100%" }}>
                                  <Typography fontSize={14} fontWeight={700} >Plate Number</Typography>
                                  <Typography fontSize={12} >{item.plate_number}</Typography>
                                </Box>
                                {CheckExtension(item.file_name) === "pdf" ? (
                                  <PdfThumbnail data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer", objectFit: "cover" }} pdfUrl={getDocumentDownloadUrl(item.file_name)} pdfRequest={getDocumentDownloadRequest(item.file_name)} fallbackSrc="/driver_forms/assets/images/pdf.png" />
                                ) : (
                                  <img data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : getDisplayUrl(item.file_name, IMAGES_URL)} alt="" />
                                )}
                                <Box width="100%" textAlign={"center"} sx={{ maxWidth: "100%", minWidth: 0 }}>
                                  <Typography fontSize={14} fontWeight={700} >Vin Number</Typography>
                                  <Typography fontSize={12} sx={{ wordBreak: "break-word", overflowWrap: "break-word" }}>{item.pin_number}</Typography>
                                </Box>
                              </Stack>
                              :
                              CheckExtension(item.file_name) === "pdf" ? (
                                <PdfThumbnail data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer", objectFit: "cover" }} pdfUrl={getDocumentDownloadUrl(item.file_name)} pdfRequest={getDocumentDownloadRequest(item.file_name)} fallbackSrc="/driver_forms/assets/images/pdf.png" />
                              ) : (
                                <img data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : getDisplayUrl(item.file_name, IMAGES_URL)} alt="" />
                              )}
                          </Grid>
                          {item.file_expiry && (
                            <Grid xs={12} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"space-evenly"}  >
                              <Typography mt={2} fontSize={12} fontWeight={900} >Expiry</Typography>
                              <Typography mt={2} mb={2} >{FormatDate(item.file_expiry)}</Typography>
                            </Grid>
                          )}


                        </Grid>
                      </Card>
                    </Grid>
                  )
                ))}
              </Grid>
              :
              publicData?.form_name === "partner_with_us" ?
                <>
                  {publicData?.partnerWithUsData?.map((item) => (
                    <Box sx={{ border: "solid 1px #e1e1e1" }} >
                      <Grid container >
                        <Grid item xs={6} >
                          <Typography style={styles.details}>Institution</Typography>
                        </Grid>
                        <Grid item xs={6} textAlign={"end"} >
                          <Typography style={styles.value}>{item.institution_name}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container >
                        <Grid item xs={6} >
                          <Typography style={styles.details}>Industry</Typography>
                        </Grid>
                        <Grid item xs={6} textAlign={"end"} >
                          <Typography style={styles.value}>{item.industry}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container >
                        <Grid item xs={6} >
                          <Typography style={styles.details}>Other Industry</Typography>
                        </Grid>
                        <Grid item xs={6} textAlign={"end"} >
                          <Typography style={styles.value}>{item.other_industry}</Typography>
                        </Grid>
                      </Grid>
                      <Grid container >
                        <Grid item xs={6} >
                          <Typography style={styles.details}>Additional Info</Typography>
                        </Grid>
                        <Grid item xs={6} textAlign={"end"} >
                          <Typography style={styles.value}>{item.additional_info}</Typography>
                        </Grid>
                      </Grid>
                    </Box>

                  ))
                  }
                  {/* <Box px={5} pt={3} >
                    <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                      {formBusy ? "Please wait...." : "Update"}
                    </Button>
                  </Box> */}
                </>
                :
                publicData?.form_name === "free_ride" ?
                  <>
                    {publicData?.freeRideData?.map((item) => (
                      <Box sx={{ border: "solid 1px #e1e1e1" }} >
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Patient Name</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{item.patient_name}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Patient Age</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{item.patient_age}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Patient Relation</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{item.patient_relation}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Receiving Facility</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{item.receiving_facility}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Transport Date</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{formatDate(item.transport_date)}</Typography>
                          </Grid>
                        </Grid>
                        <Grid container >
                          <Grid item xs={6} >
                            <Typography style={styles.details}>Additional Info</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign={"end"} >
                            <Typography style={styles.value}>{item.additional_info}</Typography>
                          </Grid>
                        </Grid>
                      </Box>


                    ))
                    }
                    {/* <Box px={5} pt={3} >
                    <Button onClick={hanldePartnerDrawer} fullWidth size="large" variant="contained" color="secondary">
                      {formBusy ? "Please wait...." : "Update"}
                    </Button>
                  </Box> */}
                  </>
                  : null
            : value === "two" ?
              <>
                <Grid container spacing={2} >

                  {oldData.map((item) => (
                    <Grid item xs={12} lg={4} key={item._id} >
                      <Card elevation={4} sx={{ height: "100%", width: "100%" }} >
                        <Grid container mt={3}  >
                          <Grid xs={12} justifyContent={"space-around"} alignItems={"center"} flexDirection={"column"} display={"flex"}  >
                            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"} spacing={2} px={1} mb={2}  >
                              {/* {RenderStatus(String(item.file_status))} */}


                            </Stack>
                            <Typography fontWeight={900} fontSize={12} mb={3} >{item.field_title}</Typography>
                            {item.file_number && (
                              <Typography mb={1} fontSize={14} >{item.file_number}</Typography>
                            )}
                            {CheckExtension(item.file_name) === "pdf" ? (
                              <PdfThumbnail data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer", objectFit: "cover" }} pdfUrl={getDocumentDownloadUrl(item.file_name)} pdfRequest={getDocumentDownloadRequest(item.file_name)} fallbackSrc="/driver_forms/assets/images/pdf.png" />
                            ) : (
                              <img data-doc-file={item.file_name} onClick={() => handleOpenModal(item.file_name)} style={{ height: 150, width: 150, cursor: "pointer" }} src={CheckExtension(item.file_name) === "docx" ? "/driver_forms/assets/images/word.png" : getDisplayUrl(item.file_name, IMAGES_URL)} alt="" />
                            )}
                          </Grid>
                          {item.file_expiry && (
                            <Grid xs={12} display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"space-evenly"}  >
                              <Typography mt={2} fontSize={12} fontWeight={900} >Expiry</Typography>
                              <Typography mt={2} mb={2} >{FormatDate(item.file_expiry)}</Typography>
                            </Grid>
                          )}


                        </Grid>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </>
              : null}
        </CardContent>
      </form>
    </Card>
  );
}






export default function PublicProfile() {
  const [text, setText] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [downloadingZip, setDownloadingZip] = useState(false);
  const profilePdfRef = useRef(null);
  const { GetDriveWithUs, loading, driveWithUsData } = DriveWithUsState()
  const { GetPublicProfile, publicData } = AuthState()
  const { id } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const dataParam = React.useMemo(() => new URLSearchParams(location.search || "").get("data"), [location.search])

  useEffect(() => {
    const payload = dataParam || id;
    if (payload) GetPublicProfile(payload);
  }, [id, dataParam])

  const getExtensionForPdf = (file) => {
    const s = String(file || "").split("?")[0].split("#")[0];
    const parts = s.split(".");
    return parts.length > 1 ? String(parts[parts.length - 1]).toLowerCase() : "";
  };

  const renderPdfFirstPageToDataUrl = async (pdfUrl) => {
    const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = Math.floor(viewport.width);
    canvas.height = Math.floor(viewport.height);
    await page.render({ canvasContext: ctx, viewport }).promise;
    return canvas.toDataURL("image/png");
  };

  const fetchImageAsDataUrl = (url) => {
    return fetch(url, { mode: "cors", credentials: "omit" })
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error("fetch failed"))))
      .then((blob) => new Promise((res, rej) => {
        const r = new FileReader();
        r.onloadend = () => res(r.result);
        r.onerror = rej;
        r.readAsDataURL(blob);
      }));
  };

  const DRIVE_WITH_US_FIELDS = ["liability_insurance", "social_security", "tlc_license", "fh1_insurance", "diamond_sticker", "car_inspection", "driver_license", "vehicle_reg"];

  const handleDownloadPdf = async () => {
    if (!profilePdfRef.current || downloading) return;
    setDownloading(true);
    const element = profilePdfRef.current;
    const origin = window.location.origin;
    const pdfIconUrl = `${origin}/driver_forms/assets/images/pdf.png`;
    const wordIconUrl = `${origin}/driver_forms/assets/images/word.png`;
    const placeholderDataUrl = "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150"><rect width="150" height="150" fill="#f0f0f0"/><text x="75" y="75" font-family="Arial" font-size="12" fill="#666" text-anchor="middle" dominant-baseline="middle">Document</text></svg>');

    const pdfReplacements = [];
    const docItems = (publicData?.driveWithUsData || []).filter((item) => DRIVE_WITH_US_FIELDS.includes(item.field_name));
    const pdfItems = docItems.filter((item) => getExtensionForPdf(item.file_name) === "pdf");
    for (const item of pdfItems) {
      const img = element.querySelector(`img[data-doc-file="${item.file_name}"]`);
      if (!img) continue;
      try {
        const req = getDocumentDownloadRequest(item.file_name);
        let blobUrlToRevoke = null;
        if (req && req.options.method === "POST") {
          const res = await fetch(req.url, req.options);
          if (res.ok) {
            const blob = await res.blob();
            blobUrlToRevoke = URL.createObjectURL(blob);
            const dataUrl = await renderPdfFirstPageToDataUrl(blobUrlToRevoke);
            pdfReplacements.push({ img, originalSrc: img.getAttribute("src") });
            img.setAttribute("src", dataUrl);
          }
          if (blobUrlToRevoke) URL.revokeObjectURL(blobUrlToRevoke);
        } else {
          const pdfUrl = getDocumentDownloadUrl(item.file_name) || getDisplayUrl(item.file_name, IMAGES_URL);
          const dataUrl = await renderPdfFirstPageToDataUrl(pdfUrl);
          pdfReplacements.push({ img, originalSrc: img.getAttribute("src") });
          img.setAttribute("src", dataUrl);
        }
      } catch (_) {}
    }

    const imgs = element.querySelectorAll ? element.querySelectorAll("img") : [];
    const remoteImgs = [];
    imgs.forEach((img) => {
      const src = (img.getAttribute("src") || "").trim();
      if (!src || src.startsWith("data:")) return;
      if (src.includes("pdf.png") || src.includes("word.png") || src.includes("output-onlinepngtools")) return;
      const dataDocFile = img.getAttribute("data-doc-file");
      const request = dataDocFile ? getDocumentDownloadRequest(dataDocFile) : null;
      const fetchUrl = !request && src.startsWith("http") ? src : null;
      if (request || fetchUrl) remoteImgs.push({ img, request, fetchUrl, originalSrc: src });
    });

    const restoreAll = () => {
      remoteImgs.forEach(({ img, originalSrc }) => { if (originalSrc) img.setAttribute("src", originalSrc); });
      pdfReplacements.forEach(({ img, originalSrc }) => img.setAttribute("src", originalSrc));
    };

    const replaceAndCapture = () => {
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        allowTaint: false,
        onclone: (_clonedDoc, node) => {
          const cloneImgs = node.querySelectorAll ? node.querySelectorAll("img") : [];
          cloneImgs.forEach((img) => {
            const src = (img.getAttribute("src") || "").trim();
            if (!src) return;
            if (src.includes("pdf.png") || src.endsWith("/pdf.png")) img.setAttribute("src", pdfIconUrl);
            else if (src.includes("word.png") || src.endsWith("/word.png")) img.setAttribute("src", wordIconUrl);
            else if (src.includes("output-onlinepngtools") || src.includes("logo")) img.setAttribute("src", `${origin}/driver_forms/assets/images/output-onlinepngtools.png`);
          });
        },
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const ratio = pdfWidth / canvas.width;
          const scaledImgH = canvas.height * ratio;
          const totalPages = Math.ceil(scaledImgH / pdfHeight) || 1;
          for (let page = 0; page < totalPages; page++) {
            if (page > 0) pdf.addPage();
            pdf.addImage(imgData, "PNG", 0, -(page * pdfHeight), pdfWidth, scaledImgH);
          }
          pdf.save(`Public-Profile-${(publicData?.name || "profile").replace(/\s+/g, "-")}.pdf`);
          restoreAll();
          setDownloading(false);
        })
        .catch((err) => {
          console.error("PDF download failed:", err);
          restoreAll();
          setDownloading(false);
        });
    };

    if (remoteImgs.length === 0) {
      setTimeout(replaceAndCapture, 300);
      return;
    }

    const fetchAsDataUrlPdf = (item) => {
      if (item.request) {
        return fetch(item.request.url, item.request.options).then((r) => (r.ok ? r.blob() : Promise.reject())).then((blob) => new Promise((res, rej) => {
          const reader = new FileReader();
          reader.onloadend = () => res(reader.result);
          reader.onerror = rej;
          reader.readAsDataURL(blob);
        }));
      }
      return fetchImageAsDataUrl(item.fetchUrl);
    };

    Promise.all(
      remoteImgs.map(({ img, request, fetchUrl }) =>
        fetchAsDataUrlPdf({ request, fetchUrl })
          .then((dataUrl) => {
            return new Promise((resolve) => {
              const newImg = new Image();
              newImg.crossOrigin = "anonymous";
              newImg.onload = () => {
                img.setAttribute("src", dataUrl);
                resolve();
              };
              newImg.onerror = () => resolve();
              newImg.src = dataUrl;
            });
          })
          .catch(() => {
            img.setAttribute("src", placeholderDataUrl);
          })
      )
    ).then(() => {
      setTimeout(replaceAndCapture, 300);
    });
  };

  const profilePayload = dataParam || id;
  const getDocumentDownloadUrl = (file_name, usePublicProfileEndpoint = true) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    // Local migrated files → public /api/uploads URL
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return resolveMediaUrl(s);
    }
    if (usePublicProfileEndpoint && profilePayload) {
      return `${API_BASE}/public_profile/document?profile=${encodeURIComponent(profilePayload)}&file_name=${encodeURIComponent(s)}`;
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`;
    }
    return `${IMAGES_URL}/${s}`;
  };

  // For shared-link (dataParam): use POST so long profile payload is in body and URLs don't break
  const getDocumentDownloadRequest = (file_name) => {
    const s = String(file_name || "").trim();
    if (!s) return null;
    if (isLocalUploadPath(s) || s.includes("/api/uploads/")) {
      return { url: resolveMediaUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (s.startsWith("http://") || s.startsWith("https://")) {
      return { url: `${API_BASE}/file/proxy?url=${encodeURIComponent(s)}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    }
    if (!profilePayload) return { url: `${IMAGES_URL}/${s}`, options: { method: "GET", mode: "cors", credentials: "omit" } };
    const usePost = !!dataParam;
    if (usePost) {
      return {
        url: `${API_BASE}/public_profile/document`,
        options: {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ profile: profilePayload, file_name: s }),
          mode: "cors",
          credentials: "omit",
        },
      };
    }
    return { url: getDocumentDownloadUrl(s), options: { method: "GET", mode: "cors", credentials: "omit" } };
  };

  const handleDownloadZip = async () => {
    const docItems = (publicData?.driveWithUsData || []).filter((item) => DRIVE_WITH_US_FIELDS.includes(item.field_name) && item.file_name);
    if (!docItems.length) return;
    setDownloadingZip(true);
    const getZipBaseName = () => {
      const fullName = [publicData?.first_name, publicData?.last_name].filter(Boolean).join(" ").trim();
      const base = fullName || publicData?.name || "profile";
      const slug = String(base)
        .replace(/[^a-zA-Z0-9_-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
      return slug || "profile";
    };
    const zip = new JSZip();
    const usedNames = {};
    const safeFileName = (title, file_name) => {
      const ext = getExtensionForPdf(file_name) || "bin";
      const base = (title || "document").replace(/[^a-zA-Z0-9\s_-]/g, "").replace(/\s+/g, "_") || "document";
      let name = `${base}.${ext}`;
      if (usedNames[name]) {
        usedNames[name] += 1;
        name = `${base}_${usedNames[name]}.${ext}`;
      } else usedNames[name] = 1;
      return name;
    };
    try {
      let added = 0;
      await Promise.all(
        docItems.map(async (item) => {
          const req = getDocumentDownloadRequest(item.file_name);
          if (!req) return;
          const res = await fetch(req.url, req.options);
          if (!res.ok) return;
          const blob = await res.blob();
          if (!blob || blob.size === 0) return;
          const fileName = safeFileName(item.field_title, item.file_name);
          zip.file(fileName, blob);
          added += 1;
        })
      );
      if (added === 0) {
        toast.error("Documents could not be fetched. Try again or check connection.");
        setDownloadingZip(false);
        return;
      }
      const content = await zip.generateAsync({ type: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(content);
      link.download = `${getZipBaseName()}.zip`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("ZIP download failed:", err);
    } finally {
      setDownloadingZip(false);
    }
  };

  const getProfilePdfBlob = async () => {
    const element = profilePdfRef.current;
    if (!element) return null;
    const origin = window.location.origin;
    const pdfIconUrl = `${origin}/driver_forms/assets/images/pdf.png`;
    const wordIconUrl = `${origin}/driver_forms/assets/images/word.png`;
    const placeholderDataUrl = "data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 150 150"><rect width="150" height="150" fill="#f0f0f0"/><text x="75" y="75" font-family="Arial" font-size="12" fill="#666" text-anchor="middle" dominant-baseline="middle">Document</text></svg>');
    const pdfReplacements = [];
    const docItems = (publicData?.driveWithUsData || []).filter((item) => DRIVE_WITH_US_FIELDS.includes(item.field_name));
    const pdfItems = docItems.filter((item) => getExtensionForPdf(item.file_name) === "pdf");
    for (const item of pdfItems) {
      const img = element.querySelector(`img[data-doc-file="${item.file_name}"]`);
      if (!img) continue;
      try {
        const req = getDocumentDownloadRequest(item.file_name);
        const pdfUrl = req ? (req.options.method === "POST" ? null : req.url) : null;
        let blobUrlToRevoke = null;
        if (req && req.options.method === "POST") {
          const res = await fetch(req.url, req.options);
          if (res.ok) {
            const blob = await res.blob();
            blobUrlToRevoke = URL.createObjectURL(blob);
            const dataUrl = await renderPdfFirstPageToDataUrl(blobUrlToRevoke);
            pdfReplacements.push({ img, originalSrc: img.getAttribute("src") });
            img.setAttribute("src", dataUrl);
          }
          if (blobUrlToRevoke) URL.revokeObjectURL(blobUrlToRevoke);
        } else if (pdfUrl) {
          const dataUrl = await renderPdfFirstPageToDataUrl(pdfUrl);
          pdfReplacements.push({ img, originalSrc: img.getAttribute("src") });
          img.setAttribute("src", dataUrl);
        }
      } catch (_) {}
    }
    const imgs = element.querySelectorAll ? element.querySelectorAll("img") : [];
    const remoteImgs = [];
    imgs.forEach((img) => {
      const src = (img.getAttribute("src") || "").trim();
      if (!src || src.startsWith("data:")) return;
      if (src.includes("pdf.png") || src.includes("word.png") || src.includes("output-onlinepngtools")) return;
      const dataDocFile = img.getAttribute("data-doc-file");
      const request = dataDocFile ? getDocumentDownloadRequest(dataDocFile) : null;
      const fetchUrl = !request && src.startsWith("http") ? src : null;
      if (request || fetchUrl) remoteImgs.push({ img, request, fetchUrl, originalSrc: src });
    });
    const restoreAll = () => {
      remoteImgs.forEach(({ img, originalSrc }) => { if (originalSrc) img.setAttribute("src", originalSrc); });
      pdfReplacements.forEach(({ img, originalSrc }) => img.setAttribute("src", originalSrc));
    };
    if (remoteImgs.length > 0) {
      const fetchAsDataUrl = (item) => {
        if (item.request) {
          return fetch(item.request.url, item.request.options).then((r) => (r.ok ? r.blob() : Promise.reject())).then((blob) => new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onloadend = () => res(reader.result);
            reader.onerror = rej;
            reader.readAsDataURL(blob);
          }));
        }
        return fetchImageAsDataUrl(item.fetchUrl);
      };
      await Promise.all(
        remoteImgs.map(({ img, request, fetchUrl }) =>
          fetchAsDataUrl({ request, fetchUrl })
            .then((dataUrl) => {
              return new Promise((resolve) => {
                const newImg = new Image();
                newImg.crossOrigin = "anonymous";
                newImg.onload = () => { img.setAttribute("src", dataUrl); resolve(); };
                newImg.onerror = () => resolve();
                newImg.src = dataUrl;
              });
            })
            .catch(() => { img.setAttribute("src", placeholderDataUrl); })
        )
      );
    }
    await new Promise((r) => setTimeout(r, 300));
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        allowTaint: false,
        onclone: (_clonedDoc, node) => {
          const cloneImgs = node.querySelectorAll ? node.querySelectorAll("img") : [];
          cloneImgs.forEach((img) => {
            const src = (img.getAttribute("src") || "").trim();
            if (!src) return;
            if (src.includes("pdf.png") || src.endsWith("/pdf.png")) img.setAttribute("src", pdfIconUrl);
            else if (src.includes("word.png") || src.endsWith("/word.png")) img.setAttribute("src", wordIconUrl);
            else if (src.includes("output-onlinepngtools") || src.includes("logo")) img.setAttribute("src", `${origin}/driver_forms/assets/images/output-onlinepngtools.png`);
          });
        },
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const ratio = pdfWidth / canvas.width;
      const scaledImgH = canvas.height * ratio;
      const totalPages = Math.ceil(scaledImgH / pdfHeight) || 1;
      for (let page = 0; page < totalPages; page++) {
        if (page > 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, -(page * pdfHeight), pdfWidth, scaledImgH);
      }
      return pdf.output("blob");
    } finally {
      restoreAll();
    }
  };

  const handleDownloadProfileZip = async () => {
    if (!profilePdfRef.current || downloadingZip) return;
    setDownloadingZip(true);
    const getZipBaseName = () => {
      const fullName = [publicData?.first_name, publicData?.last_name].filter(Boolean).join(" ").trim();
      const base = fullName || publicData?.name || "profile";
      const slug = String(base)
        .replace(/[^a-zA-Z0-9_-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
      return slug || "profile";
    };
    const zip = new JSZip();
    const usedNames = {};
    const safeFileName = (title, file_name) => {
      const ext = getExtensionForPdf(file_name) || "bin";
      const base = (title || "document").replace(/[^a-zA-Z0-9\s_-]/g, "").replace(/\s+/g, "_") || "document";
      let name = `${base}.${ext}`;
      if (usedNames[name]) { usedNames[name] += 1; name = `${base}_${usedNames[name]}.${ext}`; } else usedNames[name] = 1;
      return name;
    };
    try {
      const profileBlob = await getProfilePdfBlob();
      if (profileBlob) zip.file("Profile.pdf", profileBlob);
      const docItems = (publicData?.driveWithUsData || []).filter((item) => DRIVE_WITH_US_FIELDS.includes(item.field_name) && item.file_name);
      let docsAdded = 0;
      await Promise.all(
        docItems.map(async (item) => {
          const req = getDocumentDownloadRequest(item.file_name);
          if (!req) return;
          const res = await fetch(req.url, req.options);
          if (!res.ok) return;
          const blob = await res.blob();
          if (!blob || blob.size === 0) return;
          zip.file(safeFileName(item.field_title, item.file_name), blob);
          docsAdded += 1;
        })
      );
      if (!profileBlob && docsAdded === 0) {
        toast.error("Could not prepare profile or documents. Try again.");
        setDownloadingZip(false);
        return;
      }
      const content = await zip.generateAsync({ type: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(content);
      link.download = `${getZipBaseName()}.zip`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Profile ZIP download failed:", err);
      toast.error("Download failed. Try again.");
    } finally {
      setDownloadingZip(false);
    }
  };

  const mainpublicData = {

    title: "CEO of Apple",
    dt1: 32,
    dt2: 40,
    dt3: 50,
    firstName: { text },
    lastName: "Doe",
    midName: "Baker",
    gender: "female",
    phone: "932-555-4247",
    email: "janedoe@gmail.com",
    pass: "password123"
  };



  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          {/* Content to capture as PDF (ref on wrapper div for html2canvas) */}
          <div ref={profilePdfRef}>
          <Grid container direction="column" sx={{ overflowX: "hidden" }}>
            <Grid item xs={12}>
              <div className="cover-image" >
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                  <a onClick={() => navigate("/driver_forms")} style={{ cursor: "pointer" }}> <img src='/driver_forms/assets/images/output-onlinepngtools.png' style={{ height: 80, width: 120, marginTop: 10 }} alt="Logo" /></a>
                </Box>
                <Container sx={{ pt: 4 }}>
                  <Box sx={{ textAlign: "center" }}>
                    <h1 style={{ color: "#FFF", fontSize: 39 }}>{publicData?.name}</h1>
                  </Box>
                </Container>
              </div>
            </Grid>

            {/* Cards - normal flow */}
            <Grid
              container
              direction={{ xs: "column", md: "row" }}
              spacing={3}
              sx={{ px: { xs: 0, md: 7 }, mt: { xs: 2, md: -8 }, mb: 4 }}
            >
              <Grid item md={4}>
                <ProfileCard />
              </Grid>
              <Grid item md={8}>
                <SettingsCard
                  downloadButton={
                    <Button
                      variant="contained"
                      onClick={handleDownloadProfileZip}
                      disabled={downloadingZip}
                      size="small"
                      sx={{ backgroundColor: "#92c323", "&:hover": { backgroundColor: "#76a521" }, mr: { xs: 1, md: 2 } }}
                      startIcon={downloadingZip ? null : <i className="ri-folder-zip-line" style={{ fontSize: 18 }} />}
                    >
                      {downloadingZip ? "Preparing..." : `Download ${(String([publicData?.first_name, publicData?.last_name].filter(Boolean).join(" ").trim() || publicData?.name || "profile")).replace(/\s+/g, " ")}.zip`}
                    </Button>
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          </div>

          {/* Footer - normal flow, sab se niche */}
          <Box sx={{ marginTop: "auto" }}>
            <Footer />
          </Box>
        </div>
      </CssBaseline>
    </ThemeProvider>
  );
}
